import { render, staticRenderFns } from "./ArchivedCohortRowCards.vue?vue&type=template&id=04f00ce2"
import script from "./ArchivedCohortRowCards.vue?vue&type=script&lang=js"
export * from "./ArchivedCohortRowCards.vue?vue&type=script&lang=js"
import style0 from "./ArchivedCohortRowCards.vue?vue&type=style&index=0&id=04f00ce2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports